import { useEffect, useState } from "react";

const KEY = "lif_view_as";
export const VIEWS = [["admin", "Admin"], ["host", "Wedding host"], ["planner", "Client planner"]];
export const getViewAs = () => localStorage.getItem(KEY) || "admin";
export const setViewAs = (v) => { localStorage.setItem(KEY, v); window.dispatchEvent(new Event("lif-view-as")); };

// Admins can preview the dashboard as a host or planner; everyone else always sees their own role.
export function useViewAs(user) {
  const [v, setV] = useState(getViewAs());
  useEffect(() => { const f = () => setV(getViewAs()); window.addEventListener("lif-view-as", f); return () => window.removeEventListener("lif-view-as", f); }, []);
  return user?.role === "admin" ? v : null;
}
